import { render, staticRenderFns } from "./accessList.vue?vue&type=template&id=e99afde8&scoped=true&"
import script from "./accessList.vue?vue&type=script&lang=js&"
export * from "./accessList.vue?vue&type=script&lang=js&"
import style0 from "./accessList.vue?vue&type=style&index=0&id=e99afde8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99afde8",
  null
  
)

export default component.exports